import template from './print_history.html';
import controller from './print_history.controller';
import './print_history.scss';

let printHistoryComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default printHistoryComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/edit/print/print_history.component.js